import React from 'react'
import footLogo from '../../../img/foot-vipe-logo.jpg'
import '../../styles/FormFoot.css'

const FormFoot = () => {
  return (
    <div className='footLogo'>
        <img src={footLogo} alt="Vipe Logo" className="vipeFootLogo" />
    </div>
  )
}

export default FormFoot